import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  MotionLines,
  SkyBackdrop,
  SlopeSurface,
  TractorFigure,
} from './shared';

export default function TractorEasyIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.easy;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="İş makinesi rahat çalışıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={44} endY={34} accent={accent} />
      <TractorFigure cx={44} cy={24} tilt={-8} primary={primaryColor} />
      <MotionLines x={28} y={30} count={2} />
    </IllustrationSvg>
  );
}
